import * as actions from './actions';
import { getSpicyInitialState } from './initial_states';

export const customer = (state = null, action) => {
  switch (action.type) {
    case actions.GET_CUSTOMER:
      return action.customer;
    default:
      return state;
  }
};

export const tag = (
  state = { tags: [], spicyTags: getSpicyInitialState() },
  action
) => {
  switch (action.type) {
    case actions.GET_TAGS:
      return Object.assign({}, state, { tags: action.tags });
    case actions.GET_SPICY_TAGS:
      return Object.assign({}, state, { spicyTags: action.spicyTags });
    default:
      return state;
  }
};

export const pdpModal = (state = { visible: false, product: null }, action) => {
  switch (action.type) {
    case actions.TOGGLE_PDP_MODAL:
      return Object.assign({}, state, {
        visible: !state.pdpModalVisible,
        product: action.product,
      });
    default:
      return state;
  }
};

export const rdpModal = (state = { visible: false, pairing: null }, action) => {
  switch (action.type) {
    case actions.TOGGLE_RDP_MODAL:
      return Object.assign({}, state, {
        visible: !state.rdpModalVisible,
        pairing: action.pairing,
      });
    default:
      return state;
  }
};
